const getBookings = (state) => { return Array.prototype.concat.apply([], state.transformedItens) }

const getRequestArrayStatus = (state) => { return state.requestArrayStatus }

const getBillsBuffer = (state) => { return state.billsBuffer }

const getFetchBillsInProgress = (state) => { return state.fetchBillsInProgress }

const getTotalOnlinePaidBillItems = (state) => { return state.totalOnlinePaidBillItems }

const getTotalLocalPaidBillItems = (state) => { return state.totalLocalPaidBillItems }

const getProductList = (state) => {return state.productList }

const getReportReloadTimeout = (state) => {return state.reportReloadTimeout }

const getShowSplash = (state) => { return state.showSplash }

const getFetchBillsFailures = (state) => { return state.fetchBillsFailures }

export default {
    getFetchBillsInProgress,
    getRequestArrayStatus,
    getBillsBuffer,
    getProductList,
    getTotalLocalPaidBillItems,
    getTotalOnlinePaidBillItems,
    getBookings,
    getReportReloadTimeout,
    getShowSplash,
    getFetchBillsFailures,
}
